import { useCallback } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";

export default function SideBar({ isSidebarOpen, setIsSidebarOpen }) {
  const { associationId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const activeLinkStyle = {
    // backgroundColor: '#c4281b',
    backgroundColor: "#c4281bc4",
    borderLeft: "3px solid #000",
  };

  const activeLink = {
    color: "#ffffff",
  };

  const storedPermissions = localStorage.getItem("userPermissions");
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  // console.log(permissions, 666);

  // Define the hasPermission function
  const hasPermission = (permission) => {
    return Array.isArray(permissions) && permissions.includes(permission);
  };

  // Use useCallback to memoize the function
  const handleLinkClick = useCallback(
    (to) => {
      return (e) => {
        if (window.matchMedia("(max-width: 768px)").matches) {
          e.preventDefault();
          setIsSidebarOpen(false);
          navigate(to);
        }
      };
    },
    [setIsSidebarOpen, navigate]
  );

  return (
    // <!-- ========== App Menu ========== -->
    <div
      className={`app-menu navbar-menu ${
        isSidebarOpen ? "sidebar-open" : "sidebar-close"
      }`}
    >
      {/* <!-- LOGO --> */}
      <div className={`navbar-brand-box ${isSidebarOpen ? "" : "logo-hidden"}`}>
        {/* <!-- Dark Logo--> */}
        <Link to="/" className="logo logo-dark">
          <span className="logo-sm">
            <img src="/assets/DW-Logo.png" alt="" height="25" />
          </span>
          <span className="logo-lg">
            <img src="/assets/DW-Logo.png" alt="" height="50" />
          </span>
        </Link>
        {/* <!-- Light Logo--> */}
        <Link to="/" className="logo logo-light">
          <span className="logo-sm">
            {/* <img src="/assets/DW-Logo.png" alt="" height="36" /> */}
          </span>
          <span className="logo-lg">
            <img src="/assets/DW-Logo.png" alt="" height="80" />
          </span>
        </Link>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
        >
          <i className="ri-record-circle-line"></i>
        </button>
      </div>

      <div id="scrollbar">
        <div className="container-fluid">
          {/* <div id="two-column-menu"></div> */}
          <button
            className="close-sidebar"
            onClick={(prevState) => setIsSidebarOpen(!prevState)}
          >
            {/* <i className="ri-close-line"></i> */}
            <span className="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <ul className="navbar-nav" id="navbar-nav">
            {hasPermission("view_dashboard") && (
              <>
                <li
                  style={
                    location.pathname === "/app/dashboard"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/dashboard"
                    style={{ color: "white" }}
                    onClick={handleLinkClick("/app/dashboard")}
                  >
                    <i
                      className="ri-dashboard-line"
                      style={
                        location.pathname === "/app/dashboard" ? activeLink : {}
                      }
                    ></i>
                    <span
                      data-key="t-dashboards"
                      style={
                        location.pathname === "/app/dashboard" ? activeLink : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Dashboard
                    </span>
                  </Link>
                </li>
              </>
            )}
            {hasPermission("base_user") && (
              <>
                <li className="menu-title">
                  <span
                    data-key="t-menu"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    User Management
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/base_user"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/base_user"
                    onClick={handleLinkClick("/app/base_user")}
                  >
                    <i
                      className="ri-user-line"
                      style={
                        location.pathname === "/app/base_user" ? activeLink : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      style={
                        location.pathname === "/app/base_user" ? activeLink : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Base User
                    </span>
                  </Link>
                </li>
              </>
            )}
            {hasPermission("base_user") && (
              <li
                className="nav-item"
                style={
                  location.pathname === "/app/base_user/sub_account"
                    ? activeLinkStyle
                    : {}
                }
              >
                <Link
                  className="nav-link menu-link"
                  to="/app/base_user/sub_account"
                  onClick={handleLinkClick("/app/base_user/sub_account")}
                >
                  <i
                    className="ri-user-shared-line"
                    style={
                      location.pathname === "/app/base_user/sub_account"
                        ? activeLink
                        : {}
                    }
                  ></i>
                  <span
                    data-key="t-widgets"
                    style={
                      location.pathname === "/app/base_user/sub_account"
                        ? activeLink
                        : {}
                    }
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Sub User
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("view_user") && (
              <li
                className="nav-item"
                style={location.pathname === "/app/acl" ? activeLinkStyle : {}}
              >
                <Link
                  className="nav-link menu-link"
                  to="/app/acl"
                  onClick={handleLinkClick("/app/acl")}
                >
                  <i
                    className="ri-shield-user-line"
                    style={location.pathname === "/app/acl" ? activeLink : {}}
                  ></i>
                  <span
                    data-key="t-widgets"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                    style={location.pathname === "/app/acl" ? activeLink : {}}
                  >
                    User Access Level
                  </span>
                </Link>
              </li>
            )}
            {hasPermission("view_messaging") && (
              <>
                <li className="menu-title">
                  <span
                    data-key="t-menu"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Messaging
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/messaging" ? activeLinkStyle : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/messaging"
                    onClick={handleLinkClick("/app/messaging")}
                  >
                    <i
                      className="ri-mail-send-line"
                      style={
                        location.pathname === "/app/messaging" ? activeLink : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                      style={
                        location.pathname === "/app/messaging" ? activeLink : {}
                      }
                    >
                      Messaging
                    </span>
                  </Link>
                </li>
              </>
            )}

            {hasPermission("view_account") && (
              <>
                <li className="menu-title">
                  <span
                    data-key="t-menu"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Account Management
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/account" ? activeLinkStyle : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/account"
                    onClick={handleLinkClick("/app/account")}
                  >
                    <i
                      className="ri-briefcase-line"
                      style={
                        location.pathname === "/app/account" ? activeLink : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                      style={
                        location.pathname === "/app/account" ? activeLink : {}
                      }
                    >
                      Account
                    </span>
                  </Link>
                </li>
              </>
            )}

            {hasPermission("view_product") && (
              <>
                <li className="menu-title">
                  <span
                    data-key="t-menu"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Product Management
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/manage-category"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/manage-category"
                    onClick={handleLinkClick("/app/manage-category")}
                  >
                    <i
                      className="ri-list-unordered"
                      style={
                        location.pathname === "/app/manage-category"
                          ? activeLink
                          : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      style={
                        location.pathname === "/app/manage-category"
                          ? activeLink
                          : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Category
                    </span>
                  </Link>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/product-management"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/product-management"
                    onClick={handleLinkClick("/app/product-management")}
                  >
                    <i
                      className="ri-shopping-bag-3-line"
                      style={
                        location.pathname === "/app/product-management"
                          ? activeLink
                          : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      style={
                        location.pathname === "/app/product-management"
                          ? activeLink
                          : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Product
                    </span>
                  </Link>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/custom-product"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/custom-product"
                    onClick={handleLinkClick("/app/custom-product")}
                  >
                    <i
                      className="ri-shopping-bag-2-line"
                      style={
                        location.pathname === "/app/custom-product"
                          ? activeLink
                          : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      style={
                        location.pathname === "/app/custom-product"
                          ? activeLink
                          : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Custom Product
                    </span>
                  </Link>
                </li>
              </>
            )}
            {hasPermission("view_renewal") && (
              <>
                <li className="menu-title">
                  <span
                    data-key="t-menu"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Renewal Management
                  </span>
                </li>
                {hasPermission("view_fixed_renewal") && (
                  <li
                    className="nav-item"
                    style={
                      location.pathname === "/app/renewal-management"
                        ? activeLinkStyle
                        : {}
                    }
                  >
                    <Link
                      className="nav-link menu-link"
                      to="/app/renewal-management"
                      onClick={handleLinkClick("/app/renewal-management")}
                    >
                      <i
                        className="ri-calendar-check-line"
                        style={
                          location.pathname === "/app/renewal-management"
                            ? activeLink
                            : {}
                        }
                      ></i>
                      <span
                        data-key="t-widgets"
                        style={
                          location.pathname === "/app/renewal-management"
                            ? activeLink
                            : {}
                        }
                        className={`${isSidebarOpen ? "show" : "hidden"}`}
                      >
                        Fixed Renewal
                      </span>
                    </Link>
                  </li>
                )}
                {hasPermission("view_custom_renewal") && (
                  <li
                    className="nav-item"
                    style={
                      location.pathname === "/app/custom-renewal"
                        ? activeLinkStyle
                        : {}
                    }
                  >
                    <Link
                      className="nav-link menu-link"
                      to="/app/custom-renewal"
                      onClick={handleLinkClick("/app/custom-renewal")}
                    >
                      <i
                        className="ri-tools-line"
                        style={
                          location.pathname === "/app/custom-renewal"
                            ? activeLink
                            : {}
                        }
                      ></i>
                      <span
                        data-key="t-widgets"
                        style={
                          location.pathname === "/app/custom-renewal"
                            ? activeLink
                            : {}
                        }
                        className={`${isSidebarOpen ? "show" : "hidden"}`}
                      >
                        Custom Renewal
                      </span>
                    </Link>
                  </li>
                )}
              </>
            )}
            {hasPermission("view_custom_renewal") && (
              <>
                <li className="menu-title">
                  <span
                    data-key="t-menu"
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Invoicing
                  </span>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/invoicing"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/invoicing"
                    onClick={handleLinkClick("/app/invoicing")}
                  >
                    <i
                      className="ri-wallet-3-line"
                      style={
                        location.pathname === "/app/invoicing" ? activeLink : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      style={
                        location.pathname === "/app/invoicing" ? activeLink : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Invoice
                    </span>
                  </Link>
                </li>
                <li
                  className="nav-item"
                  style={
                    location.pathname === "/app/invoice-histories"
                      ? activeLinkStyle
                      : {}
                  }
                >
                  <Link
                    className="nav-link menu-link"
                    to="/app/invoice-histories"
                    onClick={handleLinkClick("/app/invoice-histories")}
                  >
                    <i
                      className="ri-history-line"
                      style={
                        location.pathname === "/app/invoice-histories" ? activeLink : {}
                      }
                    ></i>
                    <span
                      data-key="t-widgets"
                      style={
                        location.pathname === "/app/invoice-histories" ? activeLink : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Invoice Histories
                    </span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
        {/* <!-- Sidebar --> */}
      </div>

      <div className="sidebar-background"></div>
    </div>
  );
}
